import { Mail, Send } from "lucide-react";

export const SOCIALS = {
    x:        "https://x.com/Safe_Piggy",
    telegram: "https://t.me/safepiggy",
    email:    "mailto:support@safepiggy.xyz",
} as const;

export const XIcon = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

type Size = "sm" | "md";

export function SocialRow({ size = "sm" }: { size?: Size }) {
    const cls = size === "sm"
        ? "w-8 h-8 rounded-xl"
        : "w-9 h-9 rounded-xl";
    const icon = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";
    return (
        <div className="flex items-center gap-1.5">
            <IconLink href={SOCIALS.x}        className={cls} icon={<XIcon  className={icon} />} label="Safe Piggy on X" />
            <IconLink href={SOCIALS.telegram} className={cls} icon={<Send   className={icon} />} label="Safe Piggy on Telegram" />
            <IconLink href={SOCIALS.email}    className={cls} icon={<Mail   className={icon} />} label="Email support@safepiggy.xyz" internal />
        </div>
    );
}

function IconLink({
    href, className, icon, label, internal,
}: {
    href: string; className: string; icon: React.ReactNode; label: string; internal?: boolean;
}) {
    return (
        <a
            href={href}
            aria-label={label}
            target={internal ? undefined : "_blank"}
            rel={internal ? undefined : "noopener noreferrer"}
            className={`${className} border border-white/10 grid place-items-center text-piggy-cream/60 hover:text-piggy-cream hover:border-piggy-pink-500/40 hover:bg-piggy-pink-500/[0.08] transition-all`}
        >
            {icon}
        </a>
    );
}
